// @ts-strict-ignore
import React from 'react'
import { getDateString, handleMarks } from '..'
import { RichText } from '../../helpers/react'

export const Table = ({ children, footnotes, dateString }) => {
  return (
    <div className='PlatinumTable'>
      <div className='PlatinumTable__tableContainer'>
        <table className='PlatinumTable__table'>
          <tbody>{children}</tbody>
        </table>
      </div>
      {footnotes && (
        <div className='PlatinumTable__footnotes'>
          <RichText content={footnotes} />
        </div>
      )}
      {dateString && <div className='PlatinumTable__date'>Date {dateString}</div>}
    </div>
  )
}

export const TableRow = ({ children }) => <tr>{children}</tr>

export const TableCell = ({ children, type }) => {
  return type === 'th' ? <th>{children}</th> : <td>{children}</td>
}

interface Row {
  type: string
  value: string
  marks: any
}

interface PlatinumTableProps {
  title: string
  contents: Row[][]
  footnotes: any
  displayDate: boolean
  localDates: Date
  globalDates: Date
}

const PlatinumTable = (props: PlatinumTableProps) => {
  const { title, contents, footnotes, displayDate, localDates, globalDates } = props
  const dateString = displayDate && getDateString(localDates, globalDates)
  return (
    <div className='PlatinumTableWrapper'>
      {title && <div className='PlatinumTable__title'>{title}</div>}
      <Table footnotes={footnotes} dateString={dateString}>
        {contents.map((row, rowIndex: number) => (
          <TableRow key={rowIndex}>
            {row.map(({ type, value, marks }, colIndex) => (
              <TableCell type={type} key={colIndex}>
                {handleMarks(value, marks)}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </Table>
    </div>
  )
}

export default PlatinumTable
